import React from 'react';
import { motion } from 'framer-motion';

const partners = [
  {
    name: 'IDX',
    svg: (
      <svg viewBox="0 0 120 32" fill="currentColor">
        <rect x="2" y="8" width="8" height="16" rx="1" />
        <rect x="14" y="4" width="8" height="24" rx="1" />
        <rect x="26" y="12" width="8" height="12" rx="1" />
        <rect x="38" y="2" width="8" height="28" rx="1" />
        <rect x="50" y="8" width="8" height="16" rx="1" />
        <rect x="62" y="4" width="8" height="24" rx="1" />
        <rect x="74" y="10" width="8" height="12" rx="1" />
        <rect x="86" y="6" width="8" height="20" rx="1" />
        <rect x="98" y="2" width="8" height="28" rx="1" />
        <rect x="110" y="8" width="8" height="16" rx="1" />
      </svg>
    ),
  },
  {
    name: 'Yahoo Finance',
    svg: (
      <svg viewBox="0 0 140 32" fill="currentColor">
        <text x="0" y="24" fontSize="20" fontWeight="700" fontFamily="Arial">Y! Finance</text>
      </svg>
    ),
  },
  {
    name: 'TradingView',
    svg: (
      <svg viewBox="0 0 160 32" fill="currentColor">
        <text x="0" y="24" fontSize="18" fontWeight="700" fontFamily="Arial">TRADINGVIEW</text>
      </svg>
    ),
  },
  {
    name: 'Google',
    svg: (
      <svg viewBox="0 0 120 32" fill="currentColor">
        <text x="0" y="24" fontSize="22" fontWeight="600" fontFamily="Arial">Google</text>
      </svg>
    ),
  },
  {
    name: 'Microsoft',
    svg: (
      <svg viewBox="0 0 140 32" fill="currentColor">
        <rect x="2" y="2" width="12" height="12" rx="1" />
        <rect x="18" y="2" width="12" height="12" rx="1" />
        <rect x="2" y="18" width="12" height="12" rx="1" />
        <rect x="18" y="18" width="12" height="12" rx="1" />
        <text x="36" y="24" fontSize="18" fontWeight="600" fontFamily="Arial">Microsoft</text>
      </svg>
    ),
  },
];

function TrustedSection() {
  return (
    <section className="trusted-section">
      <div className="container">
        <p className="trusted-section__label">DIREKOMENDASIKAN & TERINTEGRASI DENGAN</p>
        <div className="row" style={{ alignItems: 'center', justifyContent: 'center' }}>
          {partners.map((partner, i) => (
            <div className="col-4 col-md-2" key={partner.name} style={{ marginBottom: 12 }}>
              <motion.div
                className="trusted-logo"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 0.6, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                {partner.svg}
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustedSection;
